import { combineReducers, configureStore } from '@reduxjs/toolkit';
import vehicleReducer from './slices/vehicleSlice';


export default configureStore({
    reducer: combineReducers({
        vehicle: vehicleReducer
    }),
})